import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { errorMessage, userType } from 'constant/const'
import axiosInstance from 'utils/axiosConfig'
import { toastError, toastSuccess } from 'utils/toastify'

const initialState = {
   channelListLoading:false,
   channelList: [],
   loading: false,
   selectedUserTypes: userType.OWNER,
   selectedChannelID: '',
   channelDetails: null,
   addBookmarkStatus: false,
   addBookmarkObj: null,
   getTopVideoList: [],
   channelChartData: null,
   channelDetailsLoading: true,
   deleteChannelFlag: false
}

export const getAllChannelListAction = createAsyncThunk(
   'settings/getAllChannelListAction',
   async (data) => {
      try {
         const res = await axiosInstance.get(`/yt/channel_list/?user_type=${data?.user_type}`)
         return res.data?.data
      } catch (error) {
         toastError(errorMessage)
         throw error.response ? error.response?.data?.message : error?.message
      }
   }
)

export const getChannelDetailsAction = createAsyncThunk(
   'settings/getChannelDetailsAction',
   async (data) => {
      try {
         const res = await axiosInstance.get(`/yt/channel/?channel_id=${data?.channel_id}`)
         return res.data?.data
      } catch (error) {
         toastError(errorMessage)
         throw error.response ? error.response?.data?.message : error?.message
      }
   }
)

export const updateBookmarkChannelAction = createAsyncThunk(
   'settings/updateBookmarkChannelAction',
   async (data) => {
      try {
         const res = await axiosInstance.post(`/yt/update_channel/`, data)
         return res.data?.data
      } catch (error) {
         toastError(errorMessage)
         throw error.response ? error.response?.data?.message : error?.message
      }
   }
)

export const getTopVideoListAction = createAsyncThunk(
   'settings/getTopVideoListAction',
   async (data) => {
      try {
         const res = await axiosInstance.get(
            `/yt/get_top_videos_list/?channel_id=${data?.channel_id}`
         )
         return res.data?.data
      } catch (error) {
         toastError(errorMessage)
         throw error.response ? error.response?.data?.message : error?.message
      }
   }
)

export const getChannelChartDataAction = createAsyncThunk(
   'settings/getChannelChartDataAction',
   async (data) => {
      try {
         const params = new URLSearchParams(data).toString()
         const res = await axiosInstance.get(`/yt/channel/chart_data/?${params}`)         
         return res.data?.data
      } catch (error) {
         toastError(errorMessage)
         throw error.response ? error.response?.data?.message : error?.message
      }
   }
)

export const deleteChannelAction = createAsyncThunk(
   'settings/deleteChannelAction',
   async (data) => {
      try {
         const params = new URLSearchParams(data).toString()
         const res = await axiosInstance.get(`/yt/delete_channel/?${params}`)
         toastSuccess(res?.data?.message)
         return res.data?.data
      } catch (error) {
         toastError(errorMessage)
         throw error.response ? error.response?.data?.message : error?.message
      }
   }
)

const SettingsSlice = createSlice({
   name: 'settings',
   initialState,
   reducers: {
      setUserType(state, action) {
         state.selectedUserTypes = action.payload
      },
      setSelectChannelId(state, action) {
         state.selectedChannelID = action.payload
      },
      resetDddBookmarkObj(state) {
         state.addBookmarkObj = null
         state.addBookmarkStatus = false
      },
      setChannelListArray(state, action) {
         state.channelList = action.payload
      },
      resetChannelData(state) {
         state.channelDetails = null
         state.getTopVideoList = []
         state.channelChartData = null
      },
      resetChannelInfoStatus(state) {
         state.channelDetailsLoading = false
         state.getTopVideoList = []
         state.channelChartData = null
      },
      resetDeleteChannelFlag(state) {
         state.deleteChannelFlag = false
      }
   },
   extraReducers: (builder) => {
      builder
         .addCase(getAllChannelListAction.pending, (state) => {
            state.channelListLoading = true
            // state.channelDetails = []
            state.addBookmarkObj = null
         })
         .addCase(getAllChannelListAction.fulfilled, (state, action) => {
            state.channelListLoading = false
            state.channelList = action.payload
            state.addBookmarkObj = null
         })
         .addCase(getAllChannelListAction.rejected, (state) => {
            state.channelListLoading = false
            state.channelList = []
            state.addBookmarkObj = null
         })
         .addCase(getChannelDetailsAction.pending, (state) => {
            state.channelDetailsLoading = true
            state.channelDetails = []
         })
         .addCase(getChannelDetailsAction.fulfilled, (state, action) => {
            state.channelDetailsLoading = false
            state.channelDetails = action.payload
         })
         .addCase(getChannelDetailsAction.rejected, (state) => {
            state.channelDetailsLoading = false
            state.channelDetails = []
         })
         .addCase(updateBookmarkChannelAction.pending, (state) => {
            state.updateBookmarkChannelAction = false
            state.addBookmarkObj = null
         })
         .addCase(updateBookmarkChannelAction.fulfilled, (state, action) => {
            state.loading = false
            state.addBookmarkStatus = true
            state.addBookmarkObj = action.payload
         })
         .addCase(updateBookmarkChannelAction.rejected, (state) => {
            state.loading = false
            state.addBookmarkStatus = false
            state.addBookmarkObj = null
         })
         .addCase(getTopVideoListAction.pending, (state) => {
            state.loading = true
            state.getTopVideoList = []
         })
         .addCase(getTopVideoListAction.fulfilled, (state, action) => {
            state.loading = false
            state.getTopVideoList = action.payload
         })
         .addCase(getTopVideoListAction.rejected, (state) => {
            state.loading = false
            state.getTopVideoList = []
         })
         .addCase(getChannelChartDataAction.pending, (state) => {
            state.loading = true
            state.channelChartData = null
         })
         .addCase(getChannelChartDataAction.fulfilled, (state, action) => {
            state.loading = false
            state.channelChartData = action.payload
         })
         .addCase(getChannelChartDataAction.rejected, (state) => {
            state.loading = false
            state.channelChartData = []
         })
         .addCase(deleteChannelAction.pending, (state) => {
            state.loading = true
            state.deleteChannelFlag = false
         })
         .addCase(deleteChannelAction.fulfilled, (state) => {
            state.loading = false
            state.deleteChannelFlag = true
         })
         .addCase(deleteChannelAction.rejected, (state) => {
            state.loading = false
            state.deleteChannelFlag = false
         })
   }
})

export const {
   setUserType,
   setSelectChannelId,
   resetDddBookmarkObj,
   setChannelListArray,
   resetChannelData,
   resetChannelInfoStatus,
   resetDeleteChannelFlag
} = SettingsSlice.actions
export default SettingsSlice.reducer
